<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      
	  <div class="backborder2 shop-sale-table" style="margin-top:10px" v-loading="query.loading">
		<table>
			<tr>
				<td class="shoptitle" align="center">优惠券名称</td>
				<td class="shoptitle" align="center">投放类型</td>
				<td class="shoptitle" align="center">优惠条件</td>
				<td class="shoptitle" align="center">使用范围</td>	
				<td class="shoptitle" align="center">编码方式</td>
			</tr>
			<tr>
				<td align="center">{{couponinfos.name}}</td>
				<td align="center">
					{{couponinfos.type}}<br/>
					<span style="width:100%;color:red" v-if="couponinfos.type=='app点击自动领取'">领取时间：{{couponinfos.collecttime}}</span>
				</td>
				<td align="center">{{couponinfos.discounttype}}</td>
				<td align="center">{{couponinfos.couptype}}<br><span v-if="couponinfos.usetype!=''" :style="couponinfos.usetype!='' && couponinfos.usetype!='全部用户' ? 'color:red' : '' ">({{couponinfos.usetype}})</span></td>
				<td align="center">{{couponinfos.create_type}}</td>
			</tr>
			<tr>
				<td class="shoptitle" align="center">是否与活动同时使用</td>
				<td class="shoptitle" align="center">创建人</td>
				<td class="shoptitle" align="center">创建时间</td>
				<td class="shoptitle" align="center">有效期</td>
				<td class="shoptitle" align="center">备注</td>	
			</tr>
			<tr>
				<td align="center">{{couponinfos.isjoin}}</td>
				<td align="center">{{couponinfos.manager}}</td>
				<td align="center">{{couponinfos.inputtime}}</td>
				<td align="center">{{couponinfos.expiretime}}</td>
				<td align="center">{{couponinfos.note}}</td>
			</tr>
			<tr>
				<td class="shoptitle" align="center">生成数量</td>
				<td class="shoptitle" align="center">每人限制领取数量</td>
				<td class="shoptitle" align="center">每次领取数量</td>
				<td class="shoptitle" align="center">已领取</td>
				<td class="shoptitle" align="center">已使用 / 未使用</td>	
			</tr>
			<tr>
				<td align="center">{{couponinfos.basenum}}</td>
				<td align="center">{{couponinfos.shoplimit}}</td>
				<td align="center">{{couponinfos.oncelimit}}</td>
				<td align="center">{{couponinfos.getticket}}</td>
				<td align="center">{{couponinfos.sureorder}} / {{couponinfos.noorder}}</td>
			</tr>
		</table>
	  </div>
	  
	  <div class="backborder2 shop-sale-table" style="margin-top:10px" v-loading="query.loading" v-if="couponinfos.gabinfos.length > 0">
	  	   <span class="shop-sales-title">指定商品 / 品牌</span>
		   <div style="width:100%;margin-top:10px">
		   	  <el-tag type="warning" v-for="(item,index) in couponinfos.gabinfos" :key="index" size="small" style="margin:0 10px 5px 0">{{item.name}}</el-tag>
	  	   </div>
	  </div>

	  
	  <!-- 优惠券信息及领取、使用记录 -->
	  <div class="backborder2 shop-sale-table" style="margin-top:10px;margin-bottom:20px" v-loading="ticketquery.loading">
	  	  <span class="shop-sales-title">优惠券信息及领取、使用记录</span>
	  	  <el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:10px">
			<el-form-item>
			    <el-select v-model="ticketquery.isget" remote clearable  filterable @change="isticketchange=true">
	          	    <el-option v-for="(item,index) in getlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			    <el-select v-model="ticketquery.isuse" remote clearable  filterable @change="isticketchange=true">
	          	    <el-option v-for="(item,index) in uselists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			   <el-input  placeholder="店员名称 / 手机号 / 所属店铺 / 优惠券码" type="text" clearable v-model="ticketquery.key" @change="isticketchange=true"/>
            </el-form-item>
			<el-form-item>
			   <el-button type="primary" size="small" round icon="el-icon-search" @click="getcouponcodelists">搜索</el-button>
			</el-form-item>
		  </el-form>
		  <table style="margin-top:0">
			<tr>
				<td class="shoptitle" align="left">优惠券码</td>
				<td class="shoptitle" align="center">领取时间</td>
				<td class="shoptitle" align="center">有效期</td>
				<td class="shoptitle" align="center">领取人</td>
				<td class="shoptitle" align="center">联系电话</td>
				<td class="shoptitle" align="center">所属店铺</td>
				<td class="shoptitle" align="center">状态</td>
				<td class="shoptitle" align="center">使用时间</td>
				<td class="shoptitle" align="center">使用订单号</td>
				<td class="shoptitle" align="center">领取备注</td>		
			</tr>
			<tr v-for="(item,index) in ticketlists" :key="index">
				<td align="left">{{item.identifier}}</td>
				<td align="center">{{item.inputtime}}</td>
				<td align="center">{{item.expiretime}}</td>
				<td align="center">{{item.truename}}</td>
				<td align="center">{{item.phone}}</td>
				<td align="center">{{item.shopname}}</td>
				<td align="center">{{item.status}}</td>
				<td align="center">{{item.userinputtime}}</td>
				<td align="center">{{item.ordernumber}}</td>
				<td align="center">
					<div>
					  <el-input type="textarea" v-model="item.discribe" :disabled="item.userid > 0 ? false : true " @blur="changedesc(item.discribe,item.usercodeid)"/>
					</div>
				</td>			
			</tr>
		  </table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="ticketpageSizeChange"
	              @current-change="ticketpageCurrentChange"
	              :current-page="ticketquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="ticketquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="ticket_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
	  </div>
	  



  </div>
  </transition>  
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
        url:this.GLOBAL.domain+"Coupon/index",
        transitionshow:true,
        actionauth:'', //功能权限
		query: {
			act:'getcouponsdetail',
			token:this.$cookies.get('token'),
			loading:false,
			id:this.childdata.id
		},
		couponinfos:{},
		isticketchange:false,
		ticketquery: {
			act:'getticketlists',
			token:this.$cookies.get('token'),
			loading:false,
			id:this.childdata.id,
			isget:'',
			isuse:'',
			key:'',
			p:1,
			rollpage:10,
		},
		ticketlists:[],
		ticket_rows:0,
		getlists:[{id:1,name:'未领取'},{id:2,name:'已领取'}],
		uselists:[{id:1,name:'未使用'},{id:2,name:'已使用'}],
		

	}
  },

  mounted(){    
    this.getactionauth();
	this.getcoupondetails();
	this.getcouponcodelists();
  },
  
  methods:{

	//获取功能权限
	getactionauth() {
		var data =this.$cookies.get('actionauth');
		data=JSON.parse(data);
		this.actionauth=data;
	},

	/** 获取下单店铺基本信息 **/
	getcoupondetails() {
		this.query.loading=true;
		var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.query.loading=false;
	        }else{
	            this.couponinfos = JSON.parse(Base64.decode(res.data.Data));
				this.query.loading=false;
	        }
        }).catch((res) => {
            this.query.loading=false;
        });
	},

	/** 获取优惠券码信息详情 **/
	getcouponcodelists() {
		if(this.isticketchange) {
			this.ticketquery.p=1;
			this.ticketquery.rollpage=10;
		}

		this.ticketquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.ticketquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.ticketquery.loading=false;
	        }else{
	            this.ticketlists = JSON.parse(Base64.decode(res.data.Data));
				this.ticket_rows=parseInt(res.data.count);
				if(this.isticketchange) this.isticketchange=false;
				this.ticketquery.loading=false;
	        }
        }).catch((res) => {
            this.ticketquery.loading=false;
        });
	},

	ticketpageSizeChange(val) {
        this.ticketquery.rollpage = val;
        this.getcouponcodelists();
    },
    ticketpageCurrentChange(val) {
        this.ticketquery.p = val;
        this.getcouponcodelists();
    },

	//修改领取备注
	changedesc(content,id) {
		var resource = this.$resource(this.url);
        resource.save({act:'changeusercode',token:this.$cookies.get('token'),id:id,content:content}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	
	        }
        }).catch((res) => {
           
        });
	},



   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shop-sale-table {padding:1% 1% 1% 1% !important;}
.shop-sale-table table {width:100%;border-radius:5px;border-collapse:collapse;border-spacing:0;border-left:1px solid rgb(221,221,221,.6);border-top:1px solid rgb(221,221,221,.6);margin-top:10px}
.shop-sale-table table td {border-right:1px solid rgb(221,221,221,.6);border-bottom:1px solid rgb(221,221,221,.6);font-size:13px;padding:10px 15px;color:#606266;}
.shop-sale-table table .shoptitle {background:rgb(221,221,221,.3);font-weight:600}
.shop-sales-title {width:100%;font-size:13px;color:#606266;margin-bottom:10px;}
.brand {width:100%;height:300px;margin-top:10px}
</style>


// WEBPACK FOOTER //
// src/components/mall/Coupondetail.vue